const modules = JSON.parse(document.getElementById('StudioComponentModules')?.textContent || '{}');
const selector = Object.keys(modules).join(',');
const started = new Set();
function enhance(root) {
  if (!selector) return;
  const elements = [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  for (const element of elements) {
    const url = modules[element.localName];
    if (!url || started.has(url)) continue;
    started.add(url);
    import(url).catch(error => { started.delete(url); console.error('Theme component could not load', error); });
  }
}
enhance(document);
const roots = new Set();
let queued = false;
new MutationObserver(records => {
  for (const record of records) for (const node of record.addedNodes) if (node instanceof Element) roots.add(node);
  if (!roots.size || queued) return;
  queued = true;
  queueMicrotask(() => { queued = false; for (const root of roots) if (root.isConnected) enhance(root); roots.clear(); });
}).observe(document.body, { childList: true, subtree: true });
